<template>
  <div class="generic-duplications-modal modal-card">
    <header class="generic-duplications-modal__header">
      <div>
        <p>Duplications</p>
        <h3>{{ content.title }}</h3>
      </div>
      <button type="button" aria-label="Fermer" @click="close">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </header>

    <section class="generic-duplications-modal__body">
      <div v-if="loading" class="generic-duplications-modal__state">
        <i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Chargement des duplications…
      </div>
      <div v-else-if="loadError" class="generic-duplications-modal__state generic-duplications-modal__state--error">
        {{ loadError }}
      </div>
      <div v-else-if="!duplications.length" class="generic-duplications-modal__state">
        Aucun domaine n’a encore dupliqué ce contenu.
      </div>
      <div v-else class="generic-duplications-modal__table-scroll">
        <table>
          <thead>
            <tr>
              <th>Domaine</th>
              <th>Application</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="duplication in duplications" :key="duplication.domain.uuid">
              <td>{{ duplication.domain.label }}</td>
              <td>{{ duplication.application.label || '—' }}</td>
              <td>{{ formatDate(duplication.duplicated_at) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { http } from '@/services/api.service'

export default {
  name: 'generic-content-duplications-modal',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      duplications: [],
      loading: true,
      loadError: ''
    }
  },
  created () {
    this.loadDuplications()
  },
  methods: {
    async loadDuplications () {
      try {
        const { data } = await http.get(
          `/internal/generic-contents/media/${this.content.type}/${this.content.uuid}/duplications`
        )
        this.duplications = Array.isArray(data?.duplications) ? data.duplications : []
      } catch (error) {
        this.loadError = 'Impossible de charger le détail des duplications.'
      } finally {
        this.loading = false
      }
    },
    formatDate (value) {
      if (!value) return '—'
      const date = new Date(String(value).replace(' ', 'T'))
      return Number.isNaN(date.getTime()) ? '—' : format(date, 'dd/MM/yyyy - HH:mm')
    },
    close () {
      if (this.$parent && typeof this.$parent.close === 'function') this.$parent.close()
    }
  }
}
</script>

<style scoped>
.generic-duplications-modal { background: #fff; border-radius: 14px; max-width: calc(100vw - 32px); overflow: hidden; width: 900px; }
.generic-duplications-modal__header { align-items: flex-start; border-bottom: 1px solid #e5e7eb; display: flex; justify-content: space-between; padding: 22px 26px; }
.generic-duplications-modal__header p { color: #2563eb; font-size: 12px; font-weight: 700; letter-spacing: .05em; margin: 0; text-transform: uppercase; }
.generic-duplications-modal__header h3 { color: #111827; font-size: 20px; font-weight: 700; margin: 3px 0 0; }
.generic-duplications-modal__header button { background: transparent; border: 0; color: #9ca3af; font-size: 18px; }
.generic-duplications-modal__body { min-height: 220px; padding: 24px 26px 30px; }
.generic-duplications-modal__state { color: #64748b; padding: 58px 20px; text-align: center; }
.generic-duplications-modal__state--error { color: #b91c1c; }
.generic-duplications-modal__table-scroll { max-height: 520px; overflow: auto; }
.generic-duplications-modal table { border-collapse: separate; border-spacing: 0; width: 100%; }
.generic-duplications-modal th { background: #f8fafc; color: #4b5563; font-size: 11px; letter-spacing: .04em; padding: 12px 14px; position: sticky; text-align: left; text-transform: uppercase; top: 0; }
.generic-duplications-modal td { border-top: 1px solid #edf0f3; color: #374151; padding: 14px; }
</style>
